import React, {useEffect, useRef} from 'react';

interface ChatInputProps {
  placeHolder: string;
  name: string;
}
const ChatInput = ({...props}: ChatInputProps) => {
  const textRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (textRef.current) {
      if (textRef.current.value.length !== 0) {
        textRef.current.style.height = '40px';
        textRef.current.style.height = `${textRef.current.scrollHeight}px`;
      } else {
        textRef.current.style.height = '40px';
      }
    }
  }, [textRef.current?.value]);

  return (
    <textarea
      ref={textRef}
      className="resize-none	w-full  bg-gray-50   rounded-[8px] h-[40px] max-h-[100px] min-h-[40px] outline-none py-[7px] px-[20px]"
      {...props}
    />
  );
};

export default ChatInput;
